export default __webpack_public_path__ + "static/media/logo_kabciamis.f4132732.png";